import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { payment, paymentverify } from './api';

const initialState = {
  loading: false,
  payment_details: []
};

const actions = {
  PAYMENTWAY: 'paymentway/PAYMENTWAY',
  VERIFYAPI: 'verifyAPI/VERIFYAPI'
};

export const paymentway = createAsyncThunk(
  actions.PAYMENTWAY,
  async (payload) => {
    const response = await payment(payload);
    return response;
  }
);
// verifyAPI/VERIFYAPI
// export const verifyAPI = createAsyncThunk(
//   actions.VERIFYAPI,
//   async (payload) => {
//     const response = await paymentverify(payload);
//     return response;
//   }
// );

export const verifyAPI = createAsyncThunk(
  'payment/verifyAPI',
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await paymentverify(paymentData);
      return response.data; // Adjust based on your API's response structure
    } catch (error) {
      // Return a rejected action with the error message
      return rejectWithValue(error.response.data);
    }
  }
);

export const PaymentwaySlice = createSlice({
  name: 'paymentgateway',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(paymentway.pending, (state) => {
        state.loading = true;
      })
      .addCase(paymentway.fulfilled, (state, action) => {
        const { order, success } = action.payload;
        console.log('data', action.payload);
        state.loading = false;
        state.payment_details = order;
        state.success = success;
      })
      .addCase(paymentway.rejected, (state) => {
        state.loading = false;
      });
  }
});

export default PaymentwaySlice.reducer;
